import React, { Component } from 'react';
import { Helmet } from "react-helmet";
import { Link } from 'react-router-dom';

class ThePlatformSolution extends Component {
	componentDidMount() {
		document.getElementById('root').classList.remove('welcome');
		document.getElementById("root").classList.remove("affiliate");
		document.getElementById('foo').classList.add('overflow');
	}
	render() {
		return (
			<div className="sub-page product">
				<Helmet>
					<title>STech - Omni-Channel is key</title>
					<meta name="description" content="STech - Omni-Channel is key pages" />
				</Helmet>
				<header className="clearfix fadeInUp">
					<div className="container">
						<div className="left"></div>
						<div className="right">
							<h1>Omni-Channel is key</h1>
							<h2>Products</h2>
						</div>
					</div>
				</header>
				<section className="clearfix fadeInUp">
					<div className="container partners">
						<div className="left"></div>
						<div className="right">
							<div className="content">
								A key for any brand is to give the customer a seamless and effective path in the relationship with your brand. The brands who can best use Omni-Channel data and understand all customers are the winners. STech makes sure that it will be the case.
							</div>
						</div>
					</div>
				</section>
				<section className="clearfix fadeInUp contact">
					<div className="container">
						<h2>We grow together</h2>
						<div className="content">
							<p>STech is a hi-tech, fast-paced company but above all we aim to create business partnerships that grow over time.</p>
							<Link to="/contact">
								Contact Us
							</Link>
						</div>
					</div>
				</section>
			</div>
		);
	}
}

export default ThePlatformSolution
